import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './ReadMore.scss';

const ReadMore = ({
  children,
  lines,
  lineHeight,
  fontSize,
  maxWidth,
}) => {
  const [expanded, handleExpand] = useState(false);

  return (
    <>
      <div
        className={`read-more position-relative font-${fontSize}`}
        style={{
          maxHeight: !expanded ? `${lineHeight * lines}em` : 'unset',
          lineHeight,
          maxWidth,
          paddingBottom: `${lineHeight}em`,
        }}
      >
        {children}
        <button
          className={classNames('issuer-primary border-0 text-uppercase read-more-btn w-100 font-14 p-0', {
            'position-absolute': !expanded,
          })}
          type="button"
          onClick={() => handleExpand(!expanded)}
        >
          <i className={classNames('icon-point-down', 'mx-1', 'd-inline-block', {
            'rotate-180': expanded,
          })}
          />
          {expanded ? 'read less' : 'read more'}
        </button>
      </div>
    </>
  );
};

ReadMore.defaultProps = {
  lineHeight: 1.875,
  maxWidth: undefined,
};

ReadMore.propTypes = {
  children: PropTypes.node.isRequired,
  lines: PropTypes.number.isRequired,
  lineHeight: PropTypes.number,
  fontSize: PropTypes.number.isRequired,
  maxWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default ReadMore;
